const Color = require("tinycolor2");

const magma = {
  // Primary
  primary: Color("#006298"),
  // Focus
  focus: Color("#027ee1"),
  focusInverse: Color("rgba(255, 255, 255, 0.7)"),
  // Foundation
  foundation: Color("#00263e"),
  foundation01: Color("#00263e"),
  foundation02: Color("#003865"),
  foundation03: Color("#00a9e0"),
  foundation04: Color("#71c5e8"),
  // Feedback
  success: Color("#3a8200"),
  success01: Color("#3a8200"),
  success02: Color("#48a200"),
  danger: Color("#c61d23"),
  // Inverse (Feedback)
  primaryInverse: Color("#70cdff"),
  successInverse: Color("#91cf60"),
  dangerInverse: Color("#f59295"),
  // Pops
  pop: Color("#e0004d"),
  pop01: Color("#e0004d"),
  pop02: Color("#fc4c02"),
  pop03: Color("#f2a900"),
  pop04: Color("#ffc72c"),
  pop05: Color("#92278f"),
  pop06: Color("#007a6d"),
  // Neutral
  neutral: Color("#3f3f3f"),
  neutral01: Color("#3f3f3f"),
  neutral02: Color("#575757"),
  neutral03: Color("#727272"),
  neutral04: Color("#8f8f8f"),
  neutral05: Color("#bfbfbf"),
  neutral06: Color("#dfdfdf"),
  neutral07: Color("#f7f7f7"),
  neutral08: Color("#ffffff"),
};
const dmax = Color("#000");
const dmin = Color("#FFF");

module.exports = { Color, magma, dmax, dmin };
